<template>
  <PageTemplate
    page-name="verify-email"
    :is-loading="!isEmailVerificationReady && getEmailVerificationStatus === null"
  >
    <SetupPasswordForm
      v-if="getSetupPasswordToken"
      :email="email"
      :token="getSetupPasswordToken"
    />
    <ConfirmationErrorForm v-else />
  </PageTemplate>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ConfirmationErrorForm from './confirmation-error-form';
import SetupPasswordForm from './setup-password-form';
import { PageTemplate } from '@/shared/ui/account';

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  async created() {
    await this.verifyEmail({ email: this.email, token: this.token });
    // Email уже підтверджено і setupToken цієї вкладки немає — пароль встановлюється
    // через «Забули пароль»
    if (this.getEmailVerificationStatus === 'verified' && !this.getSetupPasswordToken) {
      this.$router.push({ name: 'login' });
    }
  },
  components: { PageTemplate, SetupPasswordForm, ConfirmationErrorForm },
  computed: {
    ...mapGetters('registerModule', [ 'isEmailVerificationReady', 'getEmailVerificationStatus', 'getSetupPasswordToken' ]),
  },
  methods: {
    ...mapActions('registerModule', ['verifyEmail']),
  }
};
</script>
